import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

/** Deletes a payment recorded by mistake (admin only, kept in the audit log). */
export function useRentDelete() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const onError = useOnError()

  return useMutation({
    mutationFn: async (id: string) => {
      await apiClient.delete(SNA_PREFIX + `rents/${id}/`)
    },
    onSuccess: () => {
      toast.success({ message: t('paymentDeleted') })
      queryClient.invalidateQueries({ queryKey: ['rents'] })
      queryClient.invalidateQueries({ queryKey: ['flats'] })
      queryClient.invalidateQueries({ queryKey: ['dashboard-unpaid-rents'] })
    },
    onError
  })
}
